import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/i18n";
import { Users, BedDouble, DoorOpen, Star, MapPin } from "lucide-react";

export default function PropertyCard({ p }) {
  const { t } = useI18n();
  return (
    <div className="nj-card group" data-testid={`property-card-${p.slug}`}>
      <Link to={`/logements/${p.slug}`} className="relative block overflow-hidden rounded-md aspect-[4/5] bg-nj-olive">
        <img src={p.photos?.[0]} alt={p.name} loading="lazy"
          className="nj-card-img w-full h-full object-cover" />
        {p.audience && p.audience !== "voyageurs" && (
          <span data-testid={`audience-badge-${p.slug}`} className="absolute top-3 left-3 bg-nj-primary/95 text-white text-[11px] font-semibold tracking-wide px-2.5 py-1 rounded-sm">
            {p.audience === "both" ? "Voyageurs et entreprises" : "Entreprises"}
          </span>
        )}
      </Link>
      <div className="pt-4">
        <div className="flex items-start justify-between gap-3">
          <div>
            <h3 className="font-serif text-xl text-nj-text leading-tight">
              <Link to={`/logements/${p.slug}`} className="hover:text-nj-primary transition-colors">{p.name}</Link>
            </h3>
            <p className="flex items-center gap-1 text-sm text-nj-muted mt-1">
              <MapPin className="w-3.5 h-3.5" /> {p.district}
            </p>
          </div>
          {p.rating && (
            <span className="flex items-center gap-1 text-sm font-semibold text-nj-text shrink-0">
              <Star className="w-4 h-4 fill-nj-gold text-nj-gold" /> {p.rating}
            </span>
          )}
        </div>
        <div className="flex items-center gap-4 text-sm text-nj-text2 mt-3">
          <span className="flex items-center gap-1"><Users className="w-4 h-4" /> {p.capacity}</span>
          <span className="flex items-center gap-1"><BedDouble className="w-4 h-4" /> {p.bedrooms} {t("common.bedrooms")}</span>
          <span className="flex items-center gap-1"><DoorOpen className="w-4 h-4" /> {p.beds} {t("common.beds")}</span>
        </div>
        <div className="flex items-center justify-between mt-4 pt-4 border-t border-nj-olive">
          <div>
            <span className="text-xs text-nj-muted">{t("common.from")}</span>
            <div className="font-semibold text-nj-text">{p.price_from}€ <span className="text-xs font-normal text-nj-muted">/ {t("common.night")}</span></div>
          </div>
          <div className="flex gap-2">
            <Link to={`/logements/${p.slug}`} data-testid={`view-${p.slug}`}
              className="text-sm font-medium border border-nj-primary text-nj-primary px-4 py-2 rounded-sm hover:bg-nj-olive transition-colors">
              {t("common.viewProperty")}
            </Link>
            <Link to={`/logements/${p.slug}?book=1`} data-testid={`book-${p.slug}`}
              className="text-sm font-semibold bg-nj-primary text-white px-4 py-2 rounded-sm hover:bg-nj-primaryHover transition-colors">
              {t("common.book")}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
